import {Controller} from '@hotwired/stimulus';

/**
 * Bascule « Éditeur HTML » / « Éditeur visuel » d'un champ de texte mis en forme (`rich-text.md` › Rangée
 * « Insérer ») : posé sur le cadre `.rich-text`, il presse (`aria-pressed`) le bouton du mode courant, le libellé
 * des deux boutons ne changeant pas. Sans CKEditor, le champ est un textarea brut, donc en HTML ; CKEditor
 * annonce ensuite chacun de ses changements de mode par `rich-text:mode` sur le textarea (`EMSCKEditor.init`).
 */
export default class extends Controller {
  static targets = ['html', 'visual'];

  connect() {
    // CKEditor a pu être créé avant la connexion du contrôleur
    this.press(this.element.querySelector('.cke_wysiwyg_frame, .cke_wysiwyg_div') === null ? 'source' : 'wysiwyg');
  }

  update(event) {
    this.press(event.detail.mode);
  }

  press(mode) {
    if (this.hasHtmlTarget) {
      this.htmlTarget.setAttribute('aria-pressed', String(mode !== 'wysiwyg'));
    }

    if (this.hasVisualTarget) {
      this.visualTarget.setAttribute('aria-pressed', String(mode === 'wysiwyg'));
    }
  }
}
